import {
  DisplayAdStartpageSlot01,
  DisplayAdStartpageSlot02,
} from '@xing-com/crate-ads-display-ads';

export const AdSection: React.FC<{ placement: string }> = ({ placement }) => {
  return (
    <>
      {placement === 'top' && <DisplayAdStartpageSlot01 />}
      {placement === 'bottom' && <DisplayAdStartpageSlot02 />}
    </>
  );
};
